import { Component, Input, OnInit } from '@angular/core';
import { Coordinate } from 'src/app/Models/MisViajes/Coordinate';

@Component({
  selector: 'app-mapa-ruta',
  templateUrl: './mapa-ruta.component.html',
  styleUrls: ['./mapa-ruta.component.css']
})
export class MapaRutaComponent implements OnInit {

  @Input()
  coordinates: Coordinate[];
  constructor() {}

  ngOnInit(): void{
  }

  iconFirst = {
    iconUrl: './assets/img/pointer-start.svg',
    iconHeight: 10,
    iconWidth: 10
  }
  iconLast = {
    iconUrl: './assets/img/pointer-end.svg',
    iconHeight: 10,
    iconWidth: 10
  }
}
